import { API } from 'aws-amplify';

// eslint-disable-next-line import/prefer-default-export
export const getTerms = (clientId, language) => API.post('GetTerms', '/', { body: { clientId, language } });
